/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: D1 Form: Approval
 * Description: D1 Form: Approval
 * Date: 20/06/2022
 */
import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { Badge, Button } from 'react-bootstrap';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useDataTable from '../../../hooks/useDataTable';
import UrlService from '../../../services/UrlService';
import ToastifyService from '../../../services/ToastifyService';
import { layout } from '../../SvgIcon';
import { useD1Approval } from './ContextAPI';

export default function DataTable() {
    const { d1Approval, getAllData, setRowData, setShow, setIsSubmitted, modalLoading, setModalLoading } = useD1Approval();
    const axiosPrivate = useAxiosPrivate();

    const dataList = useCallback(() => {
        getAllData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const showHander = async (row) => {
        if (modalLoading) return;
        setModalLoading(true);
        setShow(true);
        setRowData(undefined);
        try {
            const response = await axiosPrivate.get(UrlService.getD1RecordByIdUrl(row.id), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const row_info = {
                d1_master_id: row.id,
                facility_name: row.facility_name,
                month: row.month,
                year: row.year,
                status: row.status,
                records: response?.data?.d1_record_list,
            };
            setRowData(row_info);
            setIsSubmitted(false);
        } catch (err) {
            setShow(false);
            setRowData(undefined);
            ToastifyService.errorNotify('Failed to load details!');
        } finally {
            setModalLoading(false);
        }
    };

    // helper function
    function getStatus(status) {
        const statusMap = {
            approved: { label: 'Approved', className: 'badgeActive' },
            received: { label: 'Received', className: 'badgeActive' },
            receive_approved: {
                label: 'Receive Approved',
                className: 'badgeActive',
            },
            d1_supplied: { label: 'D1 Supplied', className: 'badgeActive' },
            d1_supply_approved: {
                label: 'D1 Supplied Approved',
                className: 'badgeActive',
            },
            d2_generated: { label: 'D2 Generated', className: 'badgeActive' },
            d2_prepared: { label: 'D2 Prepared', className: 'badgeActive' },
            d2_supplied: { label: 'D2 Supplied', className: 'badgeActive' },
            supply_approved: {
                label: 'Supply Approved',
                className: 'badgeActive',
            },
            pending: { label: 'Pending', className: 'badgeInactive' },
        };
        return statusMap[status] || statusMap.pending;
    }

    const columns = [
        {
            name: 'Month',
            selector: (row) => row.month,
            sortable: true,
            cell: (row) =>
                row.month == 1
                    ? 'January'
                    : row.month == 2
                        ? 'February'
                        : row.month == 3
                            ? 'March'
                            : row.month == 4
                                ? 'April'
                                : row.month == 5
                                    ? 'May'
                                    : row.month == 6
                                        ? 'June'
                                        : row.month == 7
                                            ? 'July'
                                            : row.month == 8
                                                ? 'August'
                                                : row.month == 9
                                                    ? 'September'
                                                    : row.month == 10
                                                        ? 'October'
                                                        : row.month == 11
                                                            ? 'November'
                                                            : row.month == 12
                                                                ? 'December'
                                                                : '',
        },
        {
            name: 'Year',
            selector: (row) => row.year,
            sortable: true,
        },
        {
            name: 'Submitted Date',
            selector: (row) => row.submitted_date,
            format: (row) => moment(row.submitted_date).format('DD MMM YYYY'),
            sortable: true,
        },
        {
            name: 'Approved Date',
            selector: (row) => row.approval_date,
            format: (row) =>
                row.approval_date ? moment(row.approval_date).format('DD MMM YYYY') : '',
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            sortable: true,
            cell: (row) => {
                const { label, className } = getStatus(row.status);
                return (
                    <Badge className={className} bg="success">
                        {label}
                    </Badge>
                );
            },
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <Button
                    onClick={() => showHander(row)}
                    type="button"
                    className="btn btn-light actionBtn"
                    disabled={modalLoading}
                >
                    {layout}
                </Button>
            ),
        },
    ];

    return useDataTable({ columns, data: d1Approval });
}
